import { createContext, PropsWithChildren, useContext } from 'react';

type LanguageContextType = {
  locale: string;
  dir?: 'ltr' | 'rtl';
};

export const LanguageContext = createContext<LanguageContextType>({
  locale: 'en',
});

export const LanguageProvider = ({ children, dir, locale }: PropsWithChildren<LanguageContextType>) => {
  return <LanguageContext.Provider value={{ locale, dir }}>{children}</LanguageContext.Provider>;
};

export const useLanguageContext = () => {
  const context = useContext(LanguageContext);
  if (context === undefined) {
    throw new Error('useLanguageContext must be used within a LeadProvider');
  }
  return context;
};
